let helloRetailInitParams = {};
if (Shopify.country) {
  switch (Shopify.country) {
    case "US":
      helloRetailInitParams.websiteUuid = "YOUR_US_WEBSITE_UUID";
      break;
    case "DK":
      helloRetailInitParams.websiteUuid = "YOUR_DK_WEBSITE_UUID";
      break;
  }
  /* Ignore if the snippet was inserted without updating the websiteUuid.
  You can skip modifying the UUID if:
    - You only have one country/language storefront in Shopify.
    - Hello Retail only created one configuration for your store.
    - You don’t need locale-specific personalization.
  The fallback/default behavior below ⬇️ will then apply */

  if (helloRetailInitParams.websiteUuid && helloRetailInitParams.websiteUuid.startsWith("YOUR_")) {
    delete helloRetailInitParams.websiteUuid;
  }
}
if (Shopify.customerPrivacy) {
  let hr_trackingIsAllowed = Shopify.customerPrivacy.analyticsProcessingAllowed() && Shopify.customerPrivacy.marketingAllowed();
  if (!hr_trackingIsAllowed) {
    helloRetailInitParams.trackingOptOut = true;
  }
}
if (Shopify.currency && Shopify.currency.active && Shopify.currency.rate) {
  let date = new Date();
  date.setTime(date.getTime() + (60 * 24 * 365 * 60 * 1000));
  let domain = window.location.host;
  if (domain.indexOf("www.") === 0) {
    domain = domain.substring(4);
  }
  document.cookie = "hello_retail_currency" + "=" + encodeURIComponent(JSON.stringify(Shopify.currency))
    + "; expires=" + date.toGMTString()
    + ";domain=." + domain
    + ";path=/;samesite=lax";
}

window.hrq = window.hrq || [];
hrq.push(["init", helloRetailInitParams]);

document.addEventListener("visitorConsentCollected", (event) => {
  let hr_trackingIsAllowed = Shopify.customerPrivacy.analyticsProcessingAllowed() && Shopify.customerPrivacy.marketingAllowed();
  hrq = window.hrq || [];
  hrq.push(function (sdk) {
    sdk.setTrackingOptOut(!hr_trackingIsAllowed);
  });
});